module.exports = __webpack_public_path__ + "static/media/correctCanLeadToStroke.65e2480a.mp3";